import Card from "../components/Card"

const cards = [
  {
    id: 1,
    name: "mainecoonqueens",
    username: "mainecoonqueens",
    profileIMG: "profile1.jpeg",
    video: 'mainecoon.mp4',
    url: ""
  },
  {
    id: 2,
    name: "fathomlesslife",
    username: "CEO of Ocean Animals",
    profileIMG: "profile2.jpeg",
    video: 'fathomlesslife.mp4',
    url: ""
  },
  {
    id: 3,
    name: "Fishing Guy",
    username: "mafishguy",
    profileIMG: "profile3.jpeg",
    video: 'mafishguy.mp4',
    url: ""
  }
];

const Following = () => {
  return (
    <div id="Following" className="row">
      { cards.map(c => <Card key={`card-${c.id}`} card={c} />) }
    </div>
  )
}

export default Following;